import { memo } from 'react'
import Button from '~components/ui/button'
import resourceUriDecorate, { RequiredWidth } from '~utils/resource-uri-decorator'

interface ErrorFallbackProps {
  error: Error
  resetErrorBoundary: () => void
}

const ErrorFallback = memo<ErrorFallbackProps>(({ error, resetErrorBoundary }) => {
  return (
    <main className="flex flex-1 flex-col items-center justify-center h-full px-5 flex-gap-y-2 w-full">
      <img
        className="mb-4"
        src={resourceUriDecorate(`${import.meta.env.VITE_STATIC_RES}/img/error_dog.webp`, {
          width: RequiredWidth.W240,
        })}
        alt="404"
        width={138}
        height={130}
      />
      <h1 className="text-primary-600 text-headline-3 text-center">{`Oops, Something caused an error`}</h1>
      <p className="text-primary-600 text-body-3 hs:text-body-2 text-center px-5 w-full whitespace-break-spaces overflow-hidden">
        {error.message}
      </p>
      <section className="flex flex-col flex-gap-y-2 mt-6">
        <Button onClick={resetErrorBoundary}>Try again</Button>
      </section>
    </main>
  )
})

ErrorFallback.displayName = 'ErrorFallback'

export default ErrorFallback
